import React, {Fragment, Suspense} from 'react';
import { getSessionValue, showToast } from '../../../../Common/Appcommon';
import Switch from "react-switch";
import { Card, CardHeader } from 'reactstrap';
import requestApi from '../../../../services/requestApi.service';


class GlobalSettings extends React.Component{
    templateFormname = process.env.REACT_APP_TEMPLATES_FORMNAME;
    leadFormname = getSessionValue('leadformname');
    constructor(props) {
        super(props);

        this.state = {
            ctLabels : [],
            showLoader : false
        }
    }

    componentDidMount = async () => {
        this.setState({
            showLoader : true
        })
        await this.loadCallTrackingSettings();
        this.setState({
            showLoader : false,
        })

    }

    loadCallTrackingSettings = async () => {
        let params = {
            "ENTITY": "WHATSAPPPROCESS",
            "OPERATION": "callTrackingSettings",
            "ISUPDATE" : false
        };

        let response = await requestApi.processServerRequest(params);
        if(response.issuccess){
            let ctLabels = response.data;
            this.setState({
                ctLabels : ctLabels
            })
        }
    }

    changeGlobalSettingsStatus = async (name,value,title) => {
        let newStatus = value === "yes" ? "No" : "Yes";
        let toastStatus = value === "yes" ? "Disabled" : "Enabled";
        let params = {
            "ENTITY": "WHATSAPPPROCESS",
            "OPERATION": "callTrackingSettings",
            "ISUPDATE" : true,
            "field" : name,
            "status" : newStatus
        };

        let response = await requestApi.processServerRequest(params);
        if(response.issuccess){
            let ctLabels = response.data;
            this.setState({
                ctLabels : ctLabels
            })
            showToast("Updated successfully.");
        }else{
            handleErrorResponse(response.errormsg);
        }
    }

     render() {
         let {ctLabels} = this.state;
         return (
            <>
            <Fragment>
             <div className={'notifications-container kv-main-wrapper h100per w-100'}>
                <div className={'notification-list-container'}>
                   <div id="accordion" className="accordion-wrapper mb-3">
                   {ctLabels.length > 0  && ctLabels.map((ctLabel, index) => {                                      
                   return (
                    <div className={'mb-3 settings-container'}>
                    <Card>
                        <CardHeader className={'inbox-card w-100'}>
                            <div className={`notification-status`}>
                             <Switch onColor={"#23ae73"} checked={ctLabel[2].toLowerCase() === "yes"} onChange={(status) => this.changeGlobalSettingsStatus(ctLabel[1], ctLabel[2].toLowerCase(),"Global Settings")} />
                            </div>
                            <div color="" className="text-start m-0 p-0  w-100" >
                               <div className={'header-title'}>
                                 <div className={'title-info'}>
                                    <h5 className="title-text m-0 p-0">{ctLabel[0]}</h5>
                                 </div>
                               </div>
                            </div>
                        </CardHeader>
                    </Card>
                    </div>
                        )
                    })
                    }
                   </div>
                </div>
             </div>
            </Fragment>
            </>
         )
     }
 }

export default GlobalSettings;
